(() => {
  const ROOT_SELECTOR = '[data-gc-2026-hero]';

  const initialiseHero = (root) => {
    if (!root || root.dataset.gcHeroInitialised === 'true') return;

    const viewport = root.querySelector('[data-gc-hero-viewport]');
    const track = root.querySelector('[data-gc-hero-track]');
    const slides = Array.from(root.querySelectorAll('[data-gc-hero-slide]'));
    const previousButton = root.querySelector('[data-gc-hero-previous]');
    const nextButton = root.querySelector('[data-gc-hero-next]');
    const dotsContainer = root.querySelector('[data-gc-hero-dots]');

    if (!viewport || !track || slides.length === 0) return;

    root.dataset.gcHeroInitialised = 'true';

    const multipleSlides = slides.length > 1;
    root.classList.toggle('has-multiple-slides', multipleSlides);

    let activeIndex = 0;
    let pointerStartX = 0;
    let pointerCurrentX = 0;
    let isDragging = false;
    let activePointerId = null;

    const clampIndex = (index) => multipleSlides ? (index + slides.length) % slides.length : 0;

    const update = (requestedIndex) => {
      activeIndex = clampIndex(requestedIndex);
      track.style.transform = `translate3d(-${activeIndex * 100}%,0,0)`;

      slides.forEach((slide,index) => {
        const active = index === activeIndex;
        slide.classList.toggle('is-active',active);
        slide.setAttribute('aria-hidden',active ? 'false' : 'true');
      });

      root.querySelectorAll('[data-gc-hero-dot]').forEach((dot,index) => {
        const active = index === activeIndex;
        dot.classList.toggle('is-active',active);
        dot.setAttribute('aria-current',active ? 'true' : 'false');
      });
    };

    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      if (multipleSlides) {
        slides.forEach((_,index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'gc-2026-hero__dot';
          dot.setAttribute('aria-label',`Go to hero slide ${index + 1}`);
          dot.setAttribute('data-gc-hero-dot','');
          dot.addEventListener('click',() => update(index));
          dotsContainer.appendChild(dot);
        });
      }
    }

    previousButton?.addEventListener('click',() => update(activeIndex - 1));
    nextButton?.addEventListener('click',() => update(activeIndex + 1));

    const stopDragging = () => {
      if (!isDragging) return;
      const dragDistance = pointerCurrentX - pointerStartX;
      const threshold = Math.min(90,viewport.clientWidth * .16);
      root.classList.remove('is-dragging');
      isDragging = false;

      if (activePointerId !== null && viewport.hasPointerCapture?.(activePointerId)) {
        viewport.releasePointerCapture(activePointerId);
      }

      activePointerId = null;
      Math.abs(dragDistance) >= threshold
        ? update(activeIndex + (dragDistance < 0 ? 1 : -1))
        : update(activeIndex);
    };

    if (multipleSlides) {
      viewport.addEventListener('pointerdown',(event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        isDragging = true;
        activePointerId = event.pointerId;
        pointerStartX = event.clientX;
        pointerCurrentX = event.clientX;
        viewport.setPointerCapture?.(event.pointerId);
        root.classList.add('is-dragging');
      });

      viewport.addEventListener('pointermove',(event) => {
        if (!isDragging || event.pointerId !== activePointerId) return;
        pointerCurrentX = event.clientX;
        const dragPercentage = ((pointerCurrentX - pointerStartX) / viewport.clientWidth) * 100;
        track.style.transform = `translate3d(calc(-${activeIndex * 100}% + ${dragPercentage}%),0,0)`;
      });

      viewport.addEventListener('pointerup',stopDragging);
      viewport.addEventListener('pointercancel',stopDragging);
      viewport.addEventListener('lostpointercapture',stopDragging);
    }

    root.addEventListener('keydown',(event) => {
      if (!multipleSlides) return;
      if (event.key === 'ArrowLeft') { event.preventDefault(); update(activeIndex - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); update(activeIndex + 1); }
    });

    update(0);
  };

  const initialiseAll = (scope = document) => scope.querySelectorAll(ROOT_SELECTOR).forEach(initialiseHero);

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded',() => initialiseAll())
    : initialiseAll();

  document.addEventListener('shopify:section:load',(event) => initialiseAll(event.target));

  document.addEventListener('shopify:block:select',(event) => {
    const root = event.target.closest(ROOT_SELECTOR);
    const selectedSlide = event.target.closest('[data-gc-hero-slide]');
    if (!root || !selectedSlide) return;
    const slides = Array.from(root.querySelectorAll('[data-gc-hero-slide]'));
    const selectedIndex = slides.indexOf(selectedSlide);
    root.querySelectorAll('[data-gc-hero-dot]')[selectedIndex]?.click();
  });
})();